module.exports = __webpack_public_path__ + "fonts/Manrope-700-latin24_e85a026.woff2";